import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signupWithEmailAndPassword } from '../services/auth';
import { orgApi, apiErrorMessage } from '../services/api';
import { Button, Card, Field } from '../components/ui';
import logo from '../assets/icon.png';

export default function SignupPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', instituteName: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const canSubmit = form.name.trim() && form.instituteName.trim() && form.email.trim() && form.password.length >= 6;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');

    // 1. Create the Firebase account (owner is a regular user in the shared pool)
    const result = await signupWithEmailAndPassword({
      email: form.email.trim(),
      password: form.password,
      displayName: form.name.trim()
    });
    if (!result.success) {
      setBusy(false);
      setError(result.error);
      return;
    }

    // 2. Create the institute organization (signed-in user becomes owner)
    try {
      await orgApi.createOrganization({ name: form.instituteName.trim(), type: 'institute' });
      // Straight into guided setup rather than an empty analytics dashboard.
      navigate('/welcome', { replace: true });
    } catch (err) {
      setError(apiErrorMessage(err, 'Account created, but creating the organization failed. Try signing in.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-shell">
      <Card className="login-card">
        <div className="brand login-brand">
          <img src={logo} alt="PrepGen logo" className="brand-logo" />
          <span>Prepgen.ai<small>for Institutes</small></span>
        </div>
        <h1>Create your institute</h1>
        <p className="muted">Sets up your owner account and your organization in one step.</p>
        <form className="form" onSubmit={handleSubmit}>
          <Field label="Your name">
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          </Field>
          <Field label="Institute name">
            <input placeholder="e.g. Apex Coaching" value={form.instituteName}
              onChange={(e) => setForm({ ...form, instituteName: e.target.value })} />
          </Field>
          <Field label="Email">
            <input type="email" autoComplete="email" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </Field>
          <Field label="Password" hint="At least 6 characters.">
            <span className="password-wrap">
              <input type={showPassword ? 'text' : 'password'} autoComplete="new-password" value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })} />
              <button type="button" className="toggle" onClick={() => setShowPassword((v) => !v)}>
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </span>
          </Field>
          {error && <p className="login-error">{error}</p>}
          <Button type="submit" disabled={busy || !canSubmit}>
            {busy ? 'Creating…' : 'Create institute'}
          </Button>
          <p className="muted">Already have an account? <Link to="/login">Sign in</Link></p>
        </form>
      </Card>
    </div>
  );
}
